import React from 'react';
import { useTranslation } from 'react-i18next';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import { ChannelBox } from '../../../box';
import { ChannelBoxIcon } from '../../../box-icon';
import { useHumidityControl } from '../../../hooks/use-humidity-control';
import { PowerState } from '../../../power';
import SensorDetailsWrapper from '../../../sensor-details-wrapper';
import HumidityControl from '../controls';

type HumidityDetailsControlsProps = {
  channel: IDeviceChannel;
};

export const HumidityDetailsControls: React.FC<HumidityDetailsControlsProps> = ({ channel }) => {
  const { t } = useTranslation('channel-details');
  const { time } = useHumidityControl(channel);

  return (
    <SensorDetailsWrapper channel={channel}>
      <div className="details-controls grid-list-16">
        <div>
          <ChannelBox channel={channel} isListItem className="device-box--details">
            <div className="device-box__head">
              <ChannelBoxIcon channel={channel} />
              <HumidityControl channel={channel} isListItem />
            </div>
          </ChannelBox>
          {time && <div className="details-controls__detection-time">{`${t('exalus.checked')} ${time}`}</div>}
        </div>
        <PowerState channel={channel} />
      </div>
    </SensorDetailsWrapper>
  );
};
